"use strict";

var _toConsumableArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Velocity = exports.velocityFn = void 0;

var _react = require("react");

var _Gradient = require("./Gradient");

var velocityGradientFn = function velocityGradientFn() {
  return function (ticker, _ref, state) {
    var _ref2 = _slicedToArray(_ref, 1),
        point = _ref2[0];

    if (state == null) return point;
    var deltaTime = ticker.deltaTime;
    var vectors = state.map(function (vector) {
      return _toConsumableArray(vector);
    }); // deep clone

    var _loop = function _loop(index) {
      var vector = vectors[vectors.length - index];
      var previous = vectors[vectors.length - index - 1];
      vector.forEach(function (value, index) {
        return previous[index] = previous[index] + value * deltaTime;
      });
    };

    for (var index = 1; index < vectors.length; index++) {
      _loop(index);
    }

    return vectors;
  };
};

var velocityFn = function velocityFn(state) {
  var deps = state.map(function (vector) {
    return vector.join(',');
  });
  var pointsFn = (0, _react.useCallback)(function () {
    return [state];
  }, deps);
  var gradientFn = (0, _react.useCallback)(velocityGradientFn(), deps);
  return [pointsFn, gradientFn];
};

exports.velocityFn = velocityFn;

var Velocity = function Velocity(_ref3) {
  var children = _ref3.children,
      state = _ref3.state;
  var pipe = (0, _Gradient.useGradient).apply(void 0, _toConsumableArray(velocityFn(state)));
  return children(pipe);
};

exports.Velocity = Velocity;
Velocity.displayName = 'Gradient.Velocity';